<template>
  <div className="captcha" v-show="visible">
    <div className="captcha-bg">
      <transition name="fade">
        <div className="content-box" id="bindYp">
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import CaptchaManager from './Captcha.js'

export default {
  name: 'captcha',
  data () {
    return {
      visible: false,
      width: 300
    }
  },
  methods: {
    init (lang) {
      CaptchaManager.showCaptchaView(this.width, lang, (res) => {
        this.visible = false
        this.callback('scuess', res)
      }, (err) => {
        this.callback('err', err)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.captcha
  width 100%
  height 100%
  position fixed
  top 0
  left 0
  z-index 888

  .captcha-bg
    width 100%
    height 100%
    background-color rgba(0, 0, 0, 0.4)
    position absolute
    top 0
    left 0
    display flex

    .content-box
      margin auto
</style>



// WEBPACK FOOTER //
// main.vue?fca3d618